

















import { Component, Vue, Prop } from 'vue-property-decorator'

import ElsaAccordian from '@/components/accordian/accordian.vue'
import RichTextContent from '@/components/rich-text-content/rich-text-content.vue'
import { ArvioitavaKokonaisuus } from '@/types'

@Component({
  components: {
    RichTextContent,
    ElsaAccordian
  }
})
export default class ArvioitavatKokonaisuudetLista extends Vue {
  @Prop({ required: true })
  arvioitavatKokonaisuudet!: ArvioitavaKokonaisuus[]

  @Prop({ required: true, type: String })
  locale!: string
}
